import { HttpClient } from "@angular/common/http";
import { Inject, inject, Injectable } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { Observable } from "rxjs";
import { ApiUrls } from "../backoffice-urls";

@Injectable()
export class DelegationService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getDelegations(body: any): Observable<any> {
    const link = `${this.apiUrl}${ApiUrls.getDelegations}`;
    return this.http.post<any>(link, body);
  }

  getDelegationsById(id: any): Observable<any> {
    const link = `${this.apiUrl}${ApiUrls.getDelegationById}/${id}`;
    return this.http.get<any>(link);
  }

  createDelegation(body: any) {
    const link = this.apiUrl + ApiUrls.createDelegations;
    return this.http.post<any>(link, body);
  }

  updateDelegation(id: any, body: any) {
    const link = this.apiUrl + ApiUrls.UpdateDelegations + `/${id}`;
    return this.http.post<any>(link, body);
  }

  deleteDelegation(id: any) {
    const link = this.apiUrl + ApiUrls.DeleteDelegations + `/${id}`;
    return this.http.post<any>(link, id);
  }

  revokeDelegation(id: any) {
    const link = this.apiUrl + ApiUrls.RevokeDelegations + `/${id}`;
    return this.http.post<any>(link, id);
  }

  getDelegationPermission(id: any): Observable<any> {
    const link = `${this.apiUrl}${ApiUrls.getDelegationPermission}/${id}`;
    return this.http.get<any>(link);
  }

  assignDelegationPermission(body: any, id: any) {
    const link = this.apiUrl + ApiUrls.assignDelegationPermission + `/${id}`;
    return this.http.post<any>(link, body);
  }

  removeDelegationPermission(body: any, id: any, pId: any) {
    const link =
      this.apiUrl + ApiUrls.removeDelegationPermission + `/${id}` + `/${pId}`;
    return this.http.post<any>(link, body);
  }

  userDelegations(id: any): Observable<any> {
    const link = `${this.apiUrl}${ApiUrls.userDelegations}/${id}`;
    return this.http.get<any>(link);
  }
}
